import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Div from "../../../../core/et3-div";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import i18n from "../../../../constants/i18n";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import getUserConsumablesStore from "../../../../stores/user-store/consumables-store";
import Et3Button from "../../../../core/et3-button";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { isPositiveNumber } from "et3-type-guards";

const UserConsumablesForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={500}
      height={0}
      color={colors.all.transparent}
      style={{
        height: "auto"
      }}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faUser}
        type={"number"}
        label={i18n.get("USER_ID")}
        placeHolder={i18n.get("USER_ID")}
        value={getUserConsumablesStore().userID.get()}
        onChoose={(value: number) => {
          getUserConsumablesStore().setUserID(value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        size="LARGE"
        text="GET"
        type="GET"
        onClick={() => {
          getUserConsumablesStore().getUserConsumablesData();
        }}
        isEnabled={isPositiveNumber(getUserConsumablesStore().userID.get())}
      />
    </ET3Div>
  );
});

export default UserConsumablesForm;
